export enum Region {
    ER = 'ER',
    FED = 'FED'
}